/** sorted alphabetically **/
type ApiVersion = 'v1.0' | 'v2.0';
const v1: ApiVersion = 'v1.0';
const v2: ApiVersion = 'v2.0';
export const REQUEST_METHODS = {
    V1: {
        Analytics: {
            GetPowerBiReport: (id: string) => `${v1}/analytics/configuration/${id}`,
        },
        Canyon: {
            Inspections: (id: string, from: string, to: string) =>
                `${v1}/canyon/${id}/transactions?From=${from}&To=${to}`,
            InspectionColumns: (mdmid: string) =>
                `${v1}/canyon/${mdmid}/transactions/columns`,
            InspectionsPhotos: (id: string) => `${v1}/canyon/photos?WorkOrderId=${id}`,
            InspectionsPhoto: (id: string) => {
                return `${v1}/canyon/photo/${id}`;
            },
            InspectionsPhotoDownload: (id: string) => {
                return `${v1}/canyon/photo/download/${id}`;
            },
            InspectionsReport: (id: string) => `${v1}/canyon/report/${id}`,
            InspectionsThumbnail: (id: string) => {
                return `${v1}/canyon/thumbnail/${id}`;
            },
        },
        Companies: {
            ApprovedClient: (mdmId: string, companyId: string) =>
                `${v1}/companies/clients/${mdmId}/approve/${companyId}`,
            ApprovedClientUser: (mdmId: string, userId: string) =>
                `${v1}/companies/${mdmId}/users/${userId}/approve`,
            ClientDetailById: (clientId: string, timezoneOffset: number) =>
                `${v1}/companies/clients/${clientId}/${timezoneOffset}`,
            CompanyLogo: (mdmId: string, fileName: string) =>
                `${v1}/companies/${mdmId}/photo/${fileName}`,
            QrOnboarding: `${v1}/companies/qr-onboarding`,
            QrOnboardingCodes: (id: string, offset: number) =>
                `${v1}/companies/clients/${id}/qr-onboarding-codes/${offset}`,
            QrOnboardingDetails: (qrCodeId: string) =>
                `${v1}/companies/${qrCodeId}/qr-details`,
            QrOnboardingStatus: (clientId: string) =>
                `${v1}/companies/${clientId}/qr-status`,
            RejectClient: (mdmId: string, companyId: string) =>
                `${v1}/companies/clients/${mdmId}/reject/${companyId}`,
            RejectClientUser: (mdmId: string, userId: string) =>
                `${v1}/companies/${mdmId}/users/${userId}/reject`,
            SaveClient: `${v1}/companies/clients`,
            SaveClientDraft: `${v1}/companies/clients/draft`,
            VendorDetailById: (clientId: string) => `${v1}/companies/vendors/${clientId}`,
            VendorsById: (clientId: string) =>
                `${v1}/companies/clients/${clientId}/vendors`,
        },
        EForms: {
            FinalReport: (transactionId: string, trfId: string) =>
                `${v1}/eforms/transactions/${transactionId}/final-report/${trfId}`,
            Print: (id: string) => `${v1}/eforms/transactions/${id}/print-out`,
            SaveEForm: `${v1}/eforms/transactions`,
            Tabs: `${v1}/eforms/tabs`,
            Templates: `${v1}/eforms/templates`,
            Transactions: (mdmId: string) => `${v1}/eforms/${mdmId}/transactions`,
        },
        References: {
            Cities: (countryId: string, stateId: string) =>
                `${v1}/references/countries/${countryId}/states/${stateId}/cities`,
            ClientForm: `${v1}/references/client-form`,
            Countries: `${v1}/references/countries`,
            States: (countryId: string) =>
                `${v1}/references/countries/${countryId}/states`,
        },
        Search: {
            AccountManagers: `${v1}/search/account-managers`,
            Clients: `${v1}/search/clients`,
            ClientUser: (mdmId: string) => `${v1}/search/supply-chain/${mdmId}/users`,
            Email: (email: string) => `${v1}/search/users/${email}`,
            MDM: (client: string) => `${v1}/search/mdm/${client}`,
            SuperAdmins: `${v1}/search/super-admins`,
            Users: `${v1}/search/users`,
        },
        UserAccessRole: {
            AccountManager: (id: string) => `${v1}/useraccessrole/account-manager/${id}`,
            SuperAdmin: (id: string) => `${v1}/useraccessrole/super-admin/${id}`,
        },
        Users: {
            AccountManager: `${v1}/users/account-manager`,
            Client: (id: string) => `${v1}/users/companies/${id}`,
            Companies: `${v1}/users/companies`,
            CompanyDetails: (mdmId: string) => `${v1}/users/companies/detail/${mdmId}`,
            SuperAdmin: `${v1}/users/super-admin`,
            Validate: `${v1}/users/validate`,
        },
    },
    V2: {
        EForms: {
            Templates: (mdmId: string) => `${v2}/eforms/${mdmId}/templates`,
            TestSummaries: (params: string) => `${v2}/eforms/transactions?${params}`,
            TestSummariesColumns: (clientMdmId: string) =>
                `${v2}/eforms/client/columns?ClientMdmId=${clientMdmId}`,
            Transactions: (clientRequestId: string) =>
                `${v2}/eforms/transactions/${clientRequestId}`,
            SaveEForm: `${v2}/eforms/transactions`,
            GetTemplateForm: (trfId: string) => `${v2}/eforms/templates/${trfId}`,
        },
    },
    Integration: {
        NextGen: {
            AcceptTerms: 'user/terms',
            FileUpload: 'file/upload',
            FileStatus: 'file/status',
        },
    },
};
